(function () {
    'use strict';

    angular
        .module('elogbooksDirectives')
        .directive('riskManagerButton', riskManagerButton);

    riskManagerButton.$inject = ['apiClient', 'userManager', '$window', 'modulesService'];

    function riskManagerButton(apiClient, userManager, $window, modulesService) {
        return {
            restrict: 'AE',
            scope: {
                siteResource: '='
            },
            templateUrl: '/modules/directives/layout/risk-manager-button/risk-manager-button.html',
            link: function ($scope) {
                $scope.loading = true;
                $scope.url = null;
                $scope.hasPermission = userManager.hasPermission('site_permission_go_to_risk_manager');
                $scope.isEnabled = modulesService.isEnabled('meridian');

                if (
                    $scope.isEnabled
                    && $scope.hasPermission
                    && $scope.siteResource
                    && $scope.siteResource.id
                    && $scope.siteResource.reference
                ) {
                    apiClient.get('/sites/' + $scope.siteResource.id + '/riskmanager-url').then(function (response) {
                        if (response && response.url) {
                            $scope.url = response.url;
                        }
                    }).finally(function () {
                        $scope.loading = false;
                    });
                } else {
                    $scope.loading = false;
                }
            }
        };
    }
})();
